"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Destinations {
    constructor() {
        this.baseApiUrl = 'https://api.salesmanago.com';
        this.integrationsAll = '/integration/list';
        this.integrationsById = '/integration/';
    }
}
exports.default = Destinations;
